import React from 'react';
import './css/Header.css'

function Header() {
    return (
        <header className="header">
            <h1>Welcome to the project manager</h1>
        </header>
    )
}

export default Header
